define('apps/classrooms/views/pdf-utils/error-report-pdf',[
    "i18next",
    "vendor/jspdf/jspdf",
    "vendor/jszip/jszip",
    "vendor/jszip-utils/jszip-utils",
    "vendor/jsfilesaver/jsfilesaver",
    "apps/classrooms/views/pdf-utils/common",
    "vendor/jspdf-autotable-plugin/jspdf-autotable-plugin",
],
/*eslint strict: [0, "function"]*/
function(
    i18next,
    jspdf,
    JSZip,
    jsZipUtils,
    jsFilesaver,
    pdfCommonUtils,
    jspdfAutotable
) {

    /**
     * Error Report PDF for students that were not able to be issued
     *  or reissued Sign In QR Codes.
     */
    return function(model) {
        // base64 warning icon
        var WARNING_ICON = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAeCAYAAABJ/8wUAAAABHNCSVQICAgIfAhkiAAAABl0RVh0U29mdHdhcmUAZ25vbWUtc2NyZWVuc2hvdO8Dvz4AAAHkSURBVFiFzZc5SwNBGIbfXOZQCBuwCYKQwkZJIxZepXaxsRN/gCDWGn+AglVIlc5GBEuPSrZLp11QSBECaxEtDMMmHok51iJs3CSzmzm83m52Dh6e+Xb51mUYhoF/ELfsAW2ioXZ9AINoUue4ZI3omQTqxTy8ioJI8kb4HCkjrUIW9WIeANAkBI3bk78BeVGPesZVNf37IFYb7oAfgJwVYRCrDWXrtAsjakUIxGpjdHYFnmgcY0sbAMStCIFYbYRWdwEAgeVtKSvcIP02XMpkZyIYlrLCDUKzYUbGCheInY1WKddZIGGFC4Rm4+18D+XUOvTMGgBxK8wgdjYaj/edefLUWShohRnEqTb6I2KFCcT2TbGLgBUmEB4bZnitDAUZZsMfmwcA+KJTvRs5rQztR8x+AwDGkyr1WlqlHDzR+ODmdx3Ph4to1+pD+xVHIyy10SYamoUsvUPjsOIIwlIbrxf70K9SqJztUOdZa8UWhPVNGYktAAB80Wn6QYxWbGuEpTa6qelAIGw/z1ArVCPc3w0nCIDJipe2z1obHmUCHxJNsRlX8Au2qqYRmdt0BrHaAICKeiwN0Z8mIWjeXcI7k+g+k/7BEo1R03vG1GJtEw1G+eHnKELhgQ+g9J/ed+XPrqY/nyfVMoWlpYKAAAAAAElFTkSuQmCC';

        // manually apply plugin to window.jsPDF instance.
        var autoTable = require("vendor/jspdf-autotable-plugin/jspdf-autotable-plugin");
        autoTable.applyPlugin(window.jsPDF);

        this.model = model;

        var topMargin = 1,
            textMargin = .25,
            leftMargin = .6,
            vertTarget = topMargin,
            sectionSpacer = .25,
            isSite = !!this.model.get('site');

        var pdf = new jsPDF({ // eslint-disable-line new-cap
            "orientation": 'p',
            "unit": 'in',
            "format": 'letter',
        });

        var name = isSite ?
            this.model.get('site').name : this.model.get('classroom').name;

        var issuingUserName = initData.user.first_name + ' ' + initData.user.last_name;

        // set header size and bold
        pdf.setFontSize(16);
        pdf.setFontType("bold");
        pdf.text(
            'Discovery Education -' + i18next.t('Bulk QR Code Issue Error Report'),
            leftMargin,
            vertTarget
        );

        // set default text size
        pdf.setFontSize(12);

        vertTarget += textMargin + sectionSpacer;
        pdf.text(
            isSite ? i18next.t('School') : i18next.t('Classroom') + ': ' + name,
            leftMargin,
            vertTarget
        );

        // reset normal font weight
        pdf.setFontType("normal");

        vertTarget += textMargin;
        pdf.text(new Date().toLocaleDateString(), leftMargin, vertTarget);

        vertTarget += textMargin;
        pdf.text('Issued By: ' + issuingUserName, leftMargin, vertTarget);

        // set bold to show stats
        pdf.setFontType("bold");

        vertTarget += textMargin + sectionSpacer;
        pdf.text(
            this.model.get('printStudents').length + ' ' +  i18next.t('students sign-in QR Codes were successfully generated'),
            leftMargin,
            vertTarget
        );

        vertTarget += textMargin;
        pdf.text(
            this.model.get('studentsWithQRFailures').length + ' ' +  i18next.t('students sign-in QR Codes encountered errors (see table below)'),
            leftMargin,
            vertTarget
        );

        // reset font weight and build table
        pdf.setFontType("normal");

        vertTarget += textMargin + sectionSpacer;
        var columns = [
            i18next.t("Student Name"),
            i18next.t("Username"),
            i18next.t("Status"),
        ];
        var rows = this.model.get('studentsWithQRFailures').map(function(student) {
            return [
                (student.first_name && student.last_name) ?
                    student.first_name + ' ' + student.last_name : ' ',
                student.username,
                i18next.t('Error - Not Issued Yet'),
            ];
        });

        pdf.autoTable(columns, rows, {
            "theme": 'plain',
            "startY": vertTarget,
            "styles": {
                "fontSize": 12,
            },
            "bodyStyles": {
                "lineWidth": .01,
            },
            "drawCell": function(cell, tbl) {
                if (tbl.column.index === 2) {
                    var dim = cell.height - cell.padding('vertical'),
                        textPos = cell.textPos;

                    pdf.addImage(WARNING_ICON, textPos.x, textPos.y, dim, dim);

                    cell.textPos.x = textPos.x + .25;
                    cell.textPos.y = textPos.y + .025;
                }
            },
        });

        return pdf;
    };
});

